module.exports = __webpack_public_path__ + "img/brandenburg.b5e8350.webp";